function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 42 42"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#6061ED",
  width: "42",
  height: "42",
  rx: "4"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#FF6B00",
  transform: "rotate(-180 21.301 21.287)",
  x: "9.331",
  y: "9.317",
  width: "23.94",
  height: "23.94",
  rx: "11.97"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.683 24.934a.791.791 0 001.246.644l5.313-3.647a.784.784 0 000-1.281l-5.313-3.647a.791.791 0 00-1.246.644v7.287z",
  fill: "#FFF"
})));